import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ProductLeaseWizard = lazy(() => import(/* webpackChunkName: "ProductLeaseWizard" */ './components/ProductLeaseWizard'));

const productLeaseWizard = document.getElementById('product-lease-wizard');
if (productLeaseWizard != null) {
    const props = parseDatasetToProps(productLeaseWizard.dataset);

    render(
        <Suspense fallback={<></>}>
            <ProductLeaseWizard
                {...props}
            />
        </Suspense>,
        productLeaseWizard
    );
}
